/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/base-action.type';
import * as actions from 'src/types/auth-action.type';
import { AuthenticationType } from 'src/types/repository.type';

const initialState = {
  accessToken: undefined,
  clientCredentialsToken: undefined,
  userAccount: undefined,
  isSetting: false,
  error: null,
};

export const authReducer = (
  state: AuthenticationType = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.SET_AUTH:
      return {...state, isSetting: true, error: null}
    case actions.SET_AUTH_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isSetting: false,
        error: null
      };
      case actions.SET_AUTH_ERROR:
        return {
          ...state,
          isSetting: false,
          error: true
        };
    default:
      return state
  }
};
